var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { ListRow } from "../..";
import { classNames } from "../../utils/classNames";
import { getCellDataId, getCellDataTestId } from "../tableUtils";
import { TableRowAction } from "./TableRowAction";
import { V2TableCell } from "./TableCell";
import { TableDrawer } from "./TableDrawer";
import { getCellLinkProps, getBoolValueFromRow, getDrawerData, tableHasAction, getAlternatingRow, rowHasAction, } from "./utilsV2Table";
import { rowValue } from "./sharedJSS";
import { getInlineFeedback } from "./InlineFeedback";
import { useTableContext } from "../../hooks/useTableContext";
import { TableRowActionAtStart } from "./TableRowActionAtStart";
import { observe } from "mobx";
import { useFormContext } from "../../Form";
import { Observer } from "mobx-react-lite";
import { THEME } from "../../theming/theming";
import { CheckedStates } from "../../Checkbox";
export function V2TableRow(props) {
    var _a, _b;
    var _c = useTableContext(), gridClassName = _c.gridClassName, hasAction = _c.hasAction;
    var colIndex = 0;
    var item = props.item, drawer = props.drawer, rowIndex = props.rowIndex;
    var rowIsDisabled = getBoolValueFromRow(item, props.disabledRows);
    var rowHasRowAction = rowHasAction(item, props);
    var cellLink = getCellLinkProps(item, props === null || props === void 0 ? void 0 : props.link, props === null || props === void 0 ? void 0 : props.onSelect, props.linkBuilder);
    var drawerData = getDrawerData(item, drawer);
    var cellDataId = getCellDataId(rowIndex, props === null || props === void 0 ? void 0 : props.dataId);
    var cellDataTestId = getCellDataTestId(rowIndex, props === null || props === void 0 ? void 0 : props.dataTestId);
    var checkboxAtStart = ((_a = props.form) === null || _a === void 0 ? void 0 : _a.type) === "checkbox" && ((_b = props.form) === null || _b === void 0 ? void 0 : _b.viewState) !== "edit";
    if (checkboxAtStart) {
        colIndex++;
    }
    return (React.createElement(V2TableRowComponent, __assign({}, props, { gridClassName: gridClassName }),
        checkboxAtStart && (React.createElement(TableRowActionAtStart, __assign({}, props, { item: item, rowIndex: rowIndex }))), props === null || props === void 0 ? void 0 :
        props.headings.map(function (heading, i) {
            colIndex++;
            return (React.createElement(V2TableCell, __assign({}, props, { heading: heading, key: i, colIndex: colIndex, cellLink: !rowIsDisabled ? cellLink : undefined, dataId: cellDataId && "".concat(cellDataId, "-").concat(colIndex), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-").concat(colIndex), inlineFeedback: getInlineFeedback(props === null || props === void 0 ? void 0 : props.feedback, props === null || props === void 0 ? void 0 : props.rowKey, item, heading) })));
        }),
        (drawerData || (drawer === null || drawer === void 0 ? void 0 : drawer.component)) && React.createElement(TableDrawer, __assign({}, props)),
        hasAction && rowHasRowAction && React.createElement(TableRowAction, __assign({}, props))));
}
export function V2TableRowComponent(props) {
    if (props.form && props.item) {
        return React.createElement(Observer, null, function () { return React.createElement(HighlightableTableRow, __assign({}, props)); });
    }
    return React.createElement(V2TableRowDefinition, __assign({}, props));
}
export function HighlightableTableRow(props) {
    var _a;
    var form = props.form;
    var values = useFormContext().values;
    var _b = useTableContext(), isBulk = _b.isBulk, onSelectAll = _b.onSelectAll;
    var highlightedRow = function (updateCollection) {
        var highlighted = updateCollection === null || updateCollection === void 0 ? void 0 : updateCollection.filter(function (option) {
            return form && (form === null || form === void 0 ? void 0 : form.idIdentifier) && (props === null || props === void 0 ? void 0 : props.item[form.idIdentifier]) === option;
        });
        return (highlighted === null || highlighted === void 0 ? void 0 : highlighted.length) === 1;
    };
    useEffect(function () { return setInCollection(highlightedRow(values.get(form === null || form === void 0 ? void 0 : form.name))); }, [(_a = props.pagination) === null || _a === void 0 ? void 0 : _a.offset]);
    var _c = useState(highlightedRow(values.get(form === null || form === void 0 ? void 0 : form.name))), inCollection = _c[0], setInCollection = _c[1];
    observe(values, function (changes) {
        var _a, _b;
        if (isBulk &&
            ((_a = props.pagination) === null || _a === void 0 ? void 0 : _a.totalRecords) ===
                ((form === null || form === void 0 ? void 0 : form.name) && ((_b = changes.object[form === null || form === void 0 ? void 0 : form.name]) === null || _b === void 0 ? void 0 : _b.length))) {
            onSelectAll(CheckedStates.Checked);
        }
        setInCollection(highlightedRow((form === null || form === void 0 ? void 0 : form.name) && changes.object[form === null || form === void 0 ? void 0 : form.name]));
    });
    return (React.createElement(V2TableRowDefinition, __assign({}, props, { highlight: isBulk ? !inCollection : inCollection }), props.children));
}
export function V2TableRowDefinition(props) {
    var _a;
    var item = props.item, rowIndex = props.rowIndex, dataId = props.dataId, dataTestId = props.dataTestId, highlight = props.highlight;
    var classes = useTableRowClasses(rowIndex === getDataLength());
    var tableHasRowAction = tableHasAction(props);
    var rowHasRowAction = rowHasAction(item, props);
    var rowIsDisabled = getBoolValueFromRow(item, props.disabledRows);
    var getRowStyling = function (n) {
        if (highlight)
            return "";
        var rowAlternating = getAlternatingRow(n);
        if (rowAlternating === "even") {
            return classes.evenRow;
        }
        else {
            return classes.oddRow;
        }
    };
    return (React.createElement(ListRow, { className: classNames((_a = {},
            _a[classes.highlight] = !!highlight,
            _a[classes.clickableTableRow] = tableHasRowAction && rowHasRowAction && !rowIsDisabled,
            _a), classes.row, getRowStyling(rowIndex)), role: "row", ariaRowIndex: rowIndex + 1, ariaSelected: highlight, dataRowIndex: rowIndex, gridClassName: classNames(props === null || props === void 0 ? void 0 : props.gridClassName, classes.rowValue), dataId: dataId && "".concat(dataId, "-row-").concat(rowIndex), dataTestId: dataTestId && "".concat(dataTestId, "-row-").concat(rowIndex) }, props.children));
    function getDataLength() {
        var _a, _b;
        var form = props.form;
        if (form && (props === null || props === void 0 ? void 0 : props.data)) {
            return (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length;
        }
        if (form) {
            var _c = form, values = _c.values, name_1 = _c.name;
            return values[name_1].length - 1;
        }
        return (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.length;
    }
}
export function useTableRowClasses(lastRow) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var palette = THEME.palette, transitions = THEME.transitions;
    var tableTheme = useTableContext().tableTheme;
    var body = tableTheme.body;
    var useStyles = createUseStyles({
        clickableTableRow: {
            "& .list__cell--text": {
                cursor: "pointer",
            },
        },
        highlight: {
            backgroundColor: palette.primary[5].color,
            borderBottom: {
                color: palette.primary[5].color,
                style: "solid",
                width: 1,
            },
        },
        row: {
            padding: "0 !important",
            minHeight: "30px !important",
            "& a.list__cell--value": {
                color: palette.gray.charcoal.color,
                "&:hover, &:focus": {
                    color: palette.gray.charcoal.color,
                    textDecoration: "none",
                },
            },
            "& .list__cell--value": {
                "&:hover": {
                    textDecoration: "none !important",
                },
            },
        },
        rowValue: rowValue,
        evenRow: {
            backgroundColor: (_a = body === null || body === void 0 ? void 0 : body.evenRow) === null || _a === void 0 ? void 0 : _a.backgroundColor,
            transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
            "&:hover": {
                transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
                backgroundColor: (_b = body === null || body === void 0 ? void 0 : body.evenRow) === null || _b === void 0 ? void 0 : _b.backgroundHoverColor,
                "& .table-listRowAction": {
                    transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
                    backgroundColor: (_c = body === null || body === void 0 ? void 0 : body.evenRow) === null || _c === void 0 ? void 0 : _c.backgroundHoverColor,
                },
            },
            "& .table-listRowAction": {
                transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
                backgroundColor: (_d = body === null || body === void 0 ? void 0 : body.evenRow) === null || _d === void 0 ? void 0 : _d.backgroundColor,
            },
            borderBottom: !lastRow ? (_e = body === null || body === void 0 ? void 0 : body.evenRow) === null || _e === void 0 ? void 0 : _e.borderBottom : {},
        },
        oddRow: {
            backgroundColor: (_f = body === null || body === void 0 ? void 0 : body.oddRow) === null || _f === void 0 ? void 0 : _f.backgroundColor,
            transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
            "&:hover": {
                transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
                backgroundColor: (_g = body === null || body === void 0 ? void 0 : body.oddRow) === null || _g === void 0 ? void 0 : _g.backgroundHoverColor,
                "& .table-listRowAction": {
                    transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
                    backgroundColor: (_h = body === null || body === void 0 ? void 0 : body.oddRow) === null || _h === void 0 ? void 0 : _h.backgroundHoverColor,
                },
            },
            "& .table-listRowAction": {
                transition: transitions === null || transitions === void 0 ? void 0 : transitions.background,
                backgroundColor: (_j = body === null || body === void 0 ? void 0 : body.oddRow) === null || _j === void 0 ? void 0 : _j.backgroundColor,
            },
            borderBottom: !lastRow ? (_k = body === null || body === void 0 ? void 0 : body.oddRow) === null || _k === void 0 ? void 0 : _k.borderBottom : {},
        },
    });
    return useStyles();
}
